<header class="public-header">
  <a routerLink="/login" class="brand">
    <div class="mark">RE</div>
    <div>
      <strong>RE-DSM Portal</strong>
      <span>Maharashtra SLDC</span>
    </div>
  </a>

  <a routerLink="/login" class="back-link">Back to Login</a>
</header>
